export const blockIconsUiactionsGradeNew = (
	<span className='material-symbols-outlined'>grade</span>
);
